// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2qWFw","name":"Header_name__1LR5H","birthday":"Header_birthday__1nnxi","skeleton":"Header_skeleton__2WGY-"};